(function () {
    window.JN = window.JN || {};

    // Swiper supplies only the slide transform and touch gestures: on multi-swiper
    // pages the vendored 5.2 build's loop/pagination/navigation/autoplay modules and
    // its slides/realIndex state all misfire, so looping, dots, arrows and the
    // autoplay timer are driven manually off activeIndex (which stays correct).
    JN.partnersSwiper = function (rootSel, options) {
        var root = document.querySelector(rootSel);
        if (!root || typeof Swiper === 'undefined') return null;
        var opts = options || {};
        var count = root.querySelectorAll('.swiper-slide').length;
        var swiper = new Swiper(root.querySelector('.swiper-container'), {
            speed: 600,
            grabCursor: true
        });

        function goTo(idx) { swiper.slideTo((idx + count) % count); }
        function step(dir) { goTo(swiper.activeIndex + dir); }

        var pag = root.querySelector('.swiper-pagination');
        if (pag) {
            for (var i = 0; i < count; i++) {
                (function (idx) {
                    var b = document.createElement('span');
                    b.className = 'swiper-pagination-bullet';
                    b.addEventListener('click', function () { goTo(idx); });
                    pag.appendChild(b);
                })(i);
            }
            pag.classList.add('swiper-pagination-bullets', 'swiper-pagination-clickable');
            var paint = function () {
                Array.prototype.forEach.call(pag.children, function (bullet, idx) {
                    bullet.classList.toggle('swiper-pagination-bullet-active', idx === swiper.activeIndex);
                });
            };
            swiper.on('slideChange', paint);
            paint();
        }

        var nav = opts.navigation || {};
        var next = nav.nextEl && document.querySelector(nav.nextEl);
        var prev = nav.prevEl && document.querySelector(nav.prevEl);
        if (next) next.addEventListener('click', function () { step(1); });
        if (prev) prev.addEventListener('click', function () { step(-1); });

        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            var timer = setInterval(function () { step(1); }, 6000);
            root.addEventListener('mouseenter', function () { clearInterval(timer); });
            root.addEventListener('mouseleave', function () {
                timer = setInterval(function () { step(1); }, 6000);
            });
        }
        return swiper;
    };
})();
